import React, { Component } from 'react';
import * as axios  from 'axios';


function News(props) {
  return (
    <div className='news-item'>
      <span className='news-item-date'>{props.date}</span>
      <span className="news-item-title" dangerouslySetInnerHTML={{__html: props.title}}/>
    </div>
  )
}

export class NewsList extends Component {

  constructor(props) {
    super(props);
    this.state = {newsList: []}
  }

  componentDidMount() {
    axios.get('//midori-frauen.com/wp-json/posts', { params: {'filter[category_name]': 'news'}})
      .then(resp => {
        this.setState({newsList: resp.data});
      })
  }

  render() {
    const newsNodes = this.state.newsList.map(news => {
      return <News date={news.meta.news_date} title={news.title} key={news.date} />
    });

    return (
      <div className="clearfix">
        <div id="top-news-list">
          <div id="top-news-list-inner">{newsNodes}</div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Top/NewsList.jsx